<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="customStyle"
    width="21"
    height="21"
  >
    <path
      fill="#f25022"
      d="M1 1h9v9H1z"
    />
    <path
      fill="#00a4ef"
      d="M1 11h9v9H1z"
    />
    <path
      fill="#7fba00"
      d="M11 1h9v9h-9z"
    />
    <path
      fill="#ffb900"
      d="M11 11h9v9h-9z"
    />
  </svg>
</template>

<script>
export default {
  name: 'MicrosoftIcon',

  props: {
    customStyle: {
      type: String,
      default: 'w-5 h-5',
    },
  },
}
</script>
